import React from "react";
import PageHeader from "components/PageHeader";
import { Template } from "layouts/Template";
import { useEditEnfantLogic } from "./hooks/useEditEnfantLogic";
import {
  EditEnfantForm,
  EditEnfantActions,
  LoadingState,
  ErrorState,
} from "./components";

/**
 * Page d'édition du profil d'un enfant
 */
function EditEnfantPage() {
  const {
    // État
    eleve,
    isLoadingEleve,
    isLoadingClasses,
    eleveError,
    isSubmitting,
    errors,
    
    // Données
    classes,
    
    // Fonctions
    register,
    control,
    handleSubmit,
    onSubmit,
    handleCancel,
    refetchClasses,
  } = useEditEnfantLogic();

  // Afficher le chargement
  if (isLoadingEleve) {
    return (
      <Template
        header={<PageHeader title="Modifier le profil" />}
        style={{ backgroundColor: "#fff", padding: 10 }}
      >
        <LoadingState />
      </Template>
    );
  }

  // Afficher l'erreur
  if (eleveError || !eleve) {
    return (
      <Template
        header={<PageHeader title="Modifier le profil" />}
        style={{ backgroundColor: "#fff", padding: 10 }}
      >
        <ErrorState onRetry={handleCancel} />
      </Template>
    );
  }

  return (
    <Template
      header={<PageHeader title="Modifier le profil" />}
      style={{ backgroundColor: "#fff", padding: 10 }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <EditEnfantForm
          register={register}
          control={control}
          errors={errors}
          classes={classes}
          isLoadingClasses={isLoadingClasses}
          refetchClasses={refetchClasses}
          eleve={eleve}
        />
        
        <EditEnfantActions
          isSubmitting={isSubmitting}
          onCancel={handleCancel}
        />
      </form>
    </Template>
  );
}

export default EditEnfantPage;
